import axios from "axios";
import { PivotGrid, Popup } from "devextreme-react";
import Chart, {
  AdaptiveLayout,
  CommonSeriesSettings,
  Legend,
  Series,
  Size,
  Tooltip,
  ValueAxis,
} from "devextreme-react/chart";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import { useEffect, useRef, useState } from "react";

import "./index.css";
import { Export } from "devextreme-react/pivot-grid";
import { Workbook } from "exceljs";
import { exportPivotGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";

export default function PivotGridByTask(props) {
  const { pivotGridVisible, setPivotGridVisible, task } = props;

  const pivotGridRef = useRef(null);
  const chartRef = useRef(null);

  const [dataSource, setDataSource] = useState(null);
  useEffect(async () => {
    console.debug("[PivotGridByTask]");
    console.debug("task", task);

    if (
      (task.quotNo && task.codeNo) ||
      (task.contrNo && task.codeNo && task.SEQ)
    ) {
      console.debug("task", task);

      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/workR/reportByProject/pivotGridByTask?contrNo=${task.contrNo}&&quotNo=${task.quotNo}&codeNo=${task.codeNo}&SEQ=${task.SEQ}`
      );

      setDataSource(
        new PivotGridDataSource({
          fields: [
            {
              caption: "Employee",
              width: 120,
              dataField: "name",
              area: "row",
              sortBySummaryField: "Total",
            },
            {
              dataField: "startDate",
              dataType: "date",
              area: "column",
            },
            {
              groupName: "date",
              groupInterval: "month",
              visible: false,
            },
            // {
            //   dataField: "time",
            //   caption: "Total (Count)",
            //   area: "data",
            //   summaryType: "custom",
            //   allowInChart: false,
            //   calculateCustomSummary: (options) => {
            //     if (options.summaryProcess === "start") {
            //       options.totalValue = { sum: 0, count: 0 };
            //     } else if (options.summaryProcess === "calculate") {
            //       options.totalValue.sum += options.value;
            //       options.totalValue.count++;
            //     } else if (options.summaryProcess === "finalize") {
            //       const sum = options.totalValue.sum;
            //       const count = options.totalValue.count;

            //       options.totalValue = `${Number.parseFloat(sum).toFixed(
            //         2
            //       )} (${count})`;
            //     }
            //   },
            // },
            {
              caption: "Working Time",
              dataField: "time",
              dataType: "number",
              summaryType: "sum",
              area: "data",
              format: {
                type: "fixedPoint",
                precision: 2,
              },
              // visible: false,
              allowInChart: true,
            },
            {
              summaryType: "count",
              area: "data",
            },
          ],
          store: result.data,
        })
      );
    }
  }, [task.quotNo, task.codeNo]);

  const onHiding = () => {
    setPivotGridVisible(false);
  };

  const onContentReady = (e) => {
    if (chartRef.current) {
      e.component.bindChart(chartRef.current.instance, {
        dataFieldsDisplayMode: "splitPanes", // 차트 데이터 필드 표시 모드
        alternateDataFields: false,
        // dataFields: [4],
      });
    }
  };

  const customizeTooltip = (args) => {
    // args.value는 processCell에서 전달한 숫자 값 (rawSum)입니다.
    const formattedSum = Number.parseFloat(args.value).toFixed(2);

    // args.point.data.TotalDataField.value는 PivotGrid에 표시된 문자열입니다.
    // 두 값을 모두 보여줄 수 있습니다.
    const pivotGridDisplay = args.point.data.TotalDataField
      ? args.point.data.TotalDataField.value
      : `${formattedSum} (N/A)`; // fallback

    return {
      // html: `
      //       <div><b>${args.argumentText}</b></div>
      //       <div>Total Time: ${formattedSum}</div>
      //   `,
      html: `
            <div><b>${args.argumentText}: ${args.seriesName}</b></div>
            <div>Total Time: ${formattedSum}</div>
        `,
    };
  };

  const onExporting = (e) => {
    console.debug("[onExporting]");
    console.debug("e", e);
    console.debug("task", task);

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(task.taskCat);

    exportPivotGrid({
      component: e.component,
      worksheet: worksheet,
    }).then(function () {
      workbook.xlsx.writeBuffer().then(function (buffer) {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "Working Time.xlsx"
        );
      });
    });

    e.cancel = true;
  };

  return (
    <>
      <Popup
        visible={pivotGridVisible}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        title={
          task.detTask ? task.taskCat + " - " + task.detTask : task.taskCat
        }
        height={"auto"}
        onHiding={onHiding}
      >
        <Chart ref={chartRef}>
          <Size height={320} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            zIndex={10000}
            location={"center"}
          />
          <CommonSeriesSettings type={"bar"} />
          <AdaptiveLayout width={450} />
        </Chart>
        <PivotGrid
          id="pivotGridByProject"
          ref={pivotGridRef}
          dataSource={dataSource}
          allowSortingBySummary={true}
          allowSorting={true}
          showBorders={true}
          showColumnTotals={false}
          // showColumnGrandTotals={false}
          showRowTotals={false}
          // showRowGrandTotals={false}
          onContentReady={onContentReady}
          onExporting={onExporting}
        >
          <Export enabled={true} />
        </PivotGrid>
      </Popup>
    </>
  );
}
